export default {
  isAuthenticated: localStorage.getItem("access_token") !== null,
  accessToken: localStorage.getItem("access_token"),
  user:
    localStorage.getItem("user") !== null &&
    localStorage.getItem("user") !== undefined
      ? JSON.parse(localStorage.getItem("user"))
      : null,
};
